/**
 * STATIC_DEMO — hardcoded numbers taken from the original
 * newgen-executive-dashboard-v4-2026-05-14.html mock.
 *
 * Used as a fallback whenever the live API returns no rows / all zeros for a section.
 * The MaxAlly section of the report is always static and is rendered directly in JSX.
 */

export const DEMO_FACILITY_GROUP = {
  id: "demo-facility-group",
  name: "Demo Facility Group",
  facilityIds: [133852, 1011951, 1022201],
  facilityNamesById: {
    133852: "Demo Facility",
    1011951: "Demo Facility_willow creek",
    1022201: "Maxmrj Internal",
  },
};

export const STATIC_DEMO = {
  networkKpis: {
    totalSends: 194,
    uniqueReferrals: 57,
    finalized: 45,
    placementRatePct: 78.9,
    canAcceptOpen: 5,
    medianMinutesToFinalize: 12,
    avgHoursToFinalize: 18.1,
    pctWithin24h: 86.7,
    pctWithin48h: 90.0,
    pctWithin7d: 95.0,
    activeFacilities: 3,
    totalFacilities: 3,
  },
  funnel: { sent: 194, engaged: 56, responded: 52, finalized: 45 },
  activityByDay: [
    { day: "SUN", sends: 0, finalized: 0 },
    { day: "MON", sends: 5, finalized: 2 },
    { day: "TUE", sends: 5, finalized: 4 },
    { day: "WED", sends: 17, finalized: 4 },
    { day: "THU", sends: 6, finalized: 7 },
    { day: "FRI", sends: 13, finalized: 5 },
    { day: "SAT", sends: 5, finalized: 2 },
  ],
  canAcceptBacklog: [
    {
      facilityName: "Demo Facility",
      providerName: "Cedars Assisted Living",
      sentDate: "2026-04-17",
      waitDays: 25,
    },
    {
      facilityName: "Demo Facility",
      providerName: "Cedars Assisted Living",
      sentDate: "2026-04-17",
      waitDays: 25,
    },
    {
      facilityName: "Demo Facility",
      providerName: "Be Happy Be Home",
      sentDate: "2026-04-17",
      waitDays: 25,
    },
    {
      facilityName: "Demo Facility_willow creek",
      providerName: "American Homecare",
      sentDate: "2026-04-30",
      waitDays: 12,
    },
    {
      facilityName: "Maxmrj Internal",
      providerName: "Colusa Medical HH",
      sentDate: "2026-05-05",
      waitDays: 7,
    },
  ],
  facilities: [
    {
      facilityId: 133852,
      facilityName: "Demo Facility",
      uniqueRefs: 15,
      sends: 21,
      placed: 15,
      placementRatePct: 100,
      openCanAccept: 0,
      maxCaWaitDays: null,
    },
    {
      facilityId: 1011951,
      facilityName: "Demo Facility_willow creek",
      uniqueRefs: 6,
      sends: 9,
      placed: 5,
      placementRatePct: 83.3,
      openCanAccept: 1,
      maxCaWaitDays: 12,
    },
    {
      facilityId: 1022201,
      facilityName: "Maxmrj Internal",
      uniqueRefs: 5,
      sends: 7,
      placed: 4,
      placementRatePct: 80.0,
      openCanAccept: 1,
      maxCaWaitDays: 7,
    },
  ],
  speedDistribution: {
    medianMinutes: 12,
    avgHours: 18.1,
    lt24h: 86.7,
    h24_48: 3.3,
    d2_3: 1.7,
    d3_7: 5.0,
    d7_14: 3.3,
    gt14d: 1.7,
  },
  criticalAlerts: [
    {
      facilityName: "Demo Facility",
      openCanAccepts: 3,
      oldestWaitDays: 25,
      providers: ["Cedars Assisted Living", "Cedars Assisted Living", "Be Happy Be Home"],
    },
    {
      facilityName: "Demo Facility_willow creek",
      openCanAccepts: 1,
      oldestWaitDays: 12,
      providers: ["American Homecare"],
    },
  ],
  darkFacilities: [
    { name: "Bay Crest Care Center", days: 62 },
    { name: "Windsor Hayward", days: 77 },
    { name: "Park View Nursing", days: 77 },
    { name: "Rio Hondo Subacute", days: 104 },
    { name: "Windsor Vallejo", days: null },
    { name: "Alexandria Care Center", days: 162 },
    { name: "South Coast Post Acute", days: 122 },
    { name: "The Earlwood", days: 250 },
    { name: "Windsor Gardens LA", days: 122 },
  ],
};

/**
 * Section-level fallback resolver.
 * Returns API values when they exist and are non-empty, otherwise STATIC_DEMO.
 */
export function resolveSection(apiSection, staticSection, isEmpty = () => false) {
  if (!apiSection) return staticSection;
  if (isEmpty(apiSection)) return staticSection;
  return apiSection;
}

export const isEmptyKpis = (k) =>
  !k || (k.totalSends === 0 && k.uniqueReferrals === 0 && k.finalized === 0);

export const isEmptyFunnel = (f) =>
  !f || (f.sent === 0 && f.engaged === 0 && f.responded === 0 && f.finalized === 0);

export const isEmptyArray = (arr) => !Array.isArray(arr) || arr.length === 0;

export const isEmptyActivity = (arr) =>
  isEmptyArray(arr) || arr.every((d) => (d.sends || 0) === 0 && (d.finalized || 0) === 0);

export const isEmptySpeed = (s) => !s || s.medianMinutes == null;
